export default "__VITE_ASSET__CyzcVT4h__"